import { useEffect } from 'react';
import { reportScreen } from '../../services/analyticsService';
import { Page } from '../../components/layout';
import ContentHeader from '../../components/ContentHeader';
import { MyEntities } from './Components/MyEntitites';

import './index.scss';

const EntitiesPage = () => {
  useEffect(() => {
    reportScreen('entitites_page');
  }, []);

  return (
    <Page className="entities-page">
      <ContentHeader
        title="My entities"
        subTitle="Add all the entities you use to acquire properties — we’ll use public records to visualize your portfolio."
      />
      <MyEntities />
    </Page>
  );
};

export default EntitiesPage;
